const Paths = {
  home: "/",
  spin: "/spin",
  claim: "/claim",
  congra: "/congratulations",
  adminValidate: "/admin/validate",
  adminClaim: "/admin/claimed",
};

export default Paths;
